import {get, pickBy, isEqual, mergeWith, cloneDeep} from 'lodash'
const whiteLabel = require('./configEditorTabs/whiteLabelConfigEditor');
const brandConfig = require('./configEditorTabs/brandConfigEditor');
import securityConfig from './configEditorTabs/securityConfigEditor'
const servicesConfig = require('./configEditorTabs/servicesConfigEditor');
import {updateInstantAuditRateLimits} from '../../../modules/admin/instantAudits/apiUtils'


export default function (angularModule) {
  angularModule.controller('configEditorCtrl',
    ($scope, $uibModalInstance, $q, configService, billingAccount, accountsService) => {

    let accountId = billingAccount.primaryAccountId;

    $scope.form = {
      configForm : {}
    }


    $scope.billingAccount = billingAccount
    $scope.saving = false;
    $scope.loading = true;

    $scope.acctSelection = {}

    let accountParams = {accountId, showSubAccounts: true};

    $scope.instantAuditConfigModel = {}
    $scope.onInstantAuditConfigModelChange = (updated) => {
      $scope.instantAuditConfigModel = updated
    }

    accountsService.listAccounts(accountParams).then(resp => {
      let accounts = resp.accounts;
      if(accounts.length > 1){
        for (let i = 0; i < accounts.length; i++) {
          let account = accounts[i];
          if (!account.parentAccountId) {
            accounts.splice(i, 1);
            accounts.unshift(account);
          }
        }
      }
      $scope.accounts = accounts;
      $scope.hasChildAccount = $scope.accounts.length > 1;
      $scope.acctSelection.selected = $scope.accounts[0];
      loadConfigData();
    });

      $scope.$watch('acctSelection.selected', function (newVal, oldVal) {
        if (get(newVal, 'id') !== get(oldVal, 'id')) {
          loadConfigData();
        }
      }, true);

    function loadConfigData() {
      $scope.loading = true;
      $scope.accountId = $scope.acctSelection.selected.id;
      configService.getFullConfig($scope.acctSelection.selected.id)
        .then(
          // there's also a .sparse version that only has the overrides for this account's config
          resp => resp.data.config)
        .then(fullConfig => {
          $scope.whiteLabelConfigModel = whiteLabel.fromConfig(fullConfig);
          $scope.brandConfigModel = brandConfig.fromConfig(fullConfig);
          $scope.securityConfigModel = securityConfig.fromConfig(fullConfig);
          $scope.brandConfigModel.acctSelection = $scope.acctSelection;
          $scope.servicesConfigModel = servicesConfig.fromConfigAndAccount(fullConfig, $scope.acctSelection.selected);
          $scope.$watch("servicesConfigModel.account.services.listingManagement", (newValue,oldValue) => {
              if(newValue != oldValue){
                $scope.brandConfigModel.featureRestrictions.hideSuperPagesOnListingsTab = $scope.servicesConfigModel.account.services.listingManagement;
                $scope.brandConfigModel.featureRestrictions.hideYahooOnListingsTab = $scope.servicesConfigModel.account.services.listingManagement;
                $scope.brandConfigModel.featureRestrictions.hideYellowPagesOnListingsTab = $scope.servicesConfigModel.account.services.listingManagement;
              }
          })


          // TODO just make the editor aware of sparse fields rather than doing this cloning and comparison on save
          $scope.original = {
            brandConfigModel: cloneDeep($scope.brandConfigModel),
            securityConfigModel: cloneDeep($scope.securityConfigModel),
            whiteLabelConfigModel: cloneDeep($scope.whiteLabelConfigModel),
            servicesConfigModel: cloneDeep($scope.servicesConfigModel)
          }

          $scope.loading = false
      })
    }


    $scope.cancel = () => {
      $uibModalInstance.dismiss('Cancel Button');
    };

    $scope.save = () => {
      $scope.saving = true;
      const promises = [
        configService.updateFullConfig(
          get($scope.acctSelection, 'selected.id'),
          deepMergeAll(
            // TODO just make the editor aware of sparse fields rather than doing this cloning and comparison on save
            whiteLabel.toConfig(whiteLabel.sparsify($scope.original.whiteLabelConfigModel, $scope.whiteLabelConfigModel)),
            brandConfig.toConfig(brandConfig.sparsify($scope.original.brandConfigModel, $scope.brandConfigModel)),
            securityConfig.toConfig(securityConfig.sparsify($scope.original.securityConfigModel, $scope.securityConfigModel)),
            servicesConfig.toConfig(servicesConfig.sparsify($scope.original.servicesConfigModel, $scope.servicesConfigModel))
          )
        )
      ];
      if (!isEqual($scope.servicesConfigModel.account, $scope.original.servicesConfigModel.account)) {
        promises.push(accountsService.updateAccount(servicesConfig.toAccount($scope.servicesConfigModel)))
      }

      promises.push(updateInstantAuditRateLimits($scope.instantAuditConfigModel))

      $q.all(promises).then(() => {
        $scope.saving = false;
        $uibModalInstance.dismiss('Saved');

      },(error) => {
        console.error('there was an error', error)
      })
    };


  })
};


function deepMerge(object, other) {
  return mergeWith(object, other, (objValue, srcValue) => {
    // normal lodash merge merges by index. Just do a shallow array merge like server does
    if (Array.isArray(objValue)) {
      return srcValue
    }
  })
}

function deepMergeAll(...args) {
  return args.reduce(deepMerge,{})
}
